export const GET_SURAHPENDEKSANTRI_SUCCEED = "surahpendeksantri/get/succeed";
export const GET_SURAHPENDEKSANTRI_REQUEST = "surahpendeksantri/get/request";
export const GET_SURAHPENDEKSANTRI_FAILED = "surahpendeksantri/get/failed";

export const GET_SURAHPENDEKSANTRIAWAL_SUCCEED =
  "surahpendeksantri/getawal/succeed";
export const GET_SURAHPENDEKSANTRIAWAL_REQUEST =
  "surahpendeksantri/getawal/request";
export const GET_SURAHPENDEKSANTRIAWAL_FAILED =
  "surahpendeksantri/getawal/failed";

export const CREATE_SURAHPENDEKSANTRI_REQUEST =
  "surahpendeksantri/create/request";
export const CREATE_SURAHPENDEKSANTRI_SUCCEED =
  "surahpendeksantri/create/succeed";
export const CREATE_SURAHPENDEKSANTRI_FAILED =
  "surahpendeksantri/create/failed";

export const DELETE_SURAHPENDEKSANTRI_REQUEST =
  "surahpendeksantri/delete/request";
export const DELETE_SURAHPENDEKSANTRI_SUCCEED =
  "surahpendeksantri/delete/succeed";
export const DELETE_SURAHPENDEKSANTRI_FAILED =
  "surahpendeksantri/delete/failed";

export const GET_BY_ID_SURAHPENDEKSANTRI_REQUEST =
  "surahpendeksantri/getid/request";
export const GET_BY_ID_SURAHPENDEKSANTRI_SUCCEED =
  "surahpendeksantri/getid/succeed";
export const GET_BY_ID_SURAHPENDEKSANTRI_FAILED =
  "surahpendeksantri/getid/failed";

export const UPDATE_SURAHPENDEKSANTRI_REQUEST =
  "surahpendeksantri/update/request";
export const UPDATE_SURAHPENDEKSANTRI_SUCCEED =
  "surahpendeksantri/update/succeed";
export const UPDATE_SURAHPENDEKSANTRI_FAILED =
  "surahpendeksantri/update/failed";

export const GET_BY_RUMAHTAHFIDZ_SURAHPENDEKSANTRI_REQUEST =
  "surahpendeksantri/getrumahtahfidz/request";
export const GET_BY_RUMAHTAHFIDZ_SURAHPENDEKSANTRI_SUCCEED =
  "surahpendeksantri/getrumahtahfidz/succeed";
export const GET_BY_RUMAHTAHFIDZ_SURAHPENDEKSANTRI_FAILED =
  "surahpendeksantri/getrumahtahfidz/failed";

export const GET_BY_MASTERTAHFIDZ_SURAHPENDEKSANTRI_REQUEST =
  "surahpendeksantri/getbymastertahfidz/request";
export const GET_BY_MASTERTAHFIDZ_SURAHPENDEKSANTRI_SUCCEED =
  "surahpendeksantri/getbymastertahfidz/succeed";
export const GET_BY_MASTERTAHFIDZ_SURAHPENDEKSANTRI_FAILED =
  "surahpendeksantri/getbymastertahfidz/failed";

export const GET_BY_USERID_SURAHPENDEKSANTRI_REQUEST =
  "surahpendeksantri/getbyuserid/request";
export const GET_BY_USERID_SURAHPENDEKSANTRI_SUCCEED =
  "surahpendeksantri/getbyuserid/succeed";
export const GET_BY_USERID_SURAHPENDEKSANTRI_FAILED =
  "surahpendeksantri/getbyuserid/failed";
